<template>
    <li class="dropdown-tag-item" @click.stop="$emit('select', value)">
        <a href="#" :class="{ mark: mark, selected: selected }">
            <!-- <font-awesome-icon v-if="mark" icon="times" class="icon" /> -->
            <span :class="{ mark: mark, selected: selected }">{{ value.text }}</span>
        </a>
    </li>
</template>

<script>
export default {
    // name: 'select-item-tag',
    props: ['value', 'selected', 'mark'],
    data() {
        return {};
    },
};
</script>

<style lang="scss">
li.dropdown-tag-item {
    padding: 5px 20px;

    > a {
        // position: relative;
        white-space: nowrap;
        color: #9ca5b0;
        font-size: 13px;
        line-height: 13px;
        transition: color 0.25s ease;
        font-weight: 500;
        // padding: 7px 9px;
        // padding-top: 7px;
        // outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: none;

        background: none;
        background-color: transparent;

        &.selected {
            // color: #3b3e47;
            color: #151b25;
        }

        span {
            vertical-align: middle;

            &.mark {
                padding-left: 16px;
            }

            &.selected {
                padding-left: 0;
                &:before {
                    content: '\d7';
                    font-size: 20px;
                    font-weight: bold;
                    color: #8e919b;
                    margin-right: 4px;
                    // vertical-align: middle;
                }
            }
        }
    }

    &:hover > a {
        color: #3b3e47;
    }
}
</style>
